export const passportOptions = {
  maxLength: 20,
  minLength: 2,
  allowedCharacters: /^[A-Z0-9\/\\-]+$/i,
};

export function execute(value: string | unknown): string[] {
  const errorMessages = {
    INVALID_TYPE: "INVALID_TYPE",
    TOO_SHORT: "TOO_SHORT",
    TOO_LONG: "TOO_LONG",
    INVALID_CHARACTERS: "INVALID_CHARACTERS",
  };

  const errors: string[] = [];

  if (typeof value !== "string") {
    errors.push(errorMessages.INVALID_TYPE);
    return errors;
  }

  if (value.length < passportOptions.minLength) {
    errors.push(errorMessages.TOO_SHORT);
    return errors;
  }

  if (value.length > passportOptions.maxLength) {
    errors.push(errorMessages.TOO_LONG);
    return errors;
  }

  if (!passportOptions.allowedCharacters.test(value)) {
    errors.push(errorMessages.INVALID_CHARACTERS);
  }

  return errors;
}

export function isValid(value: string | unknown): boolean {
  return execute(value).length === 0;
}
